import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@/context/SessionContext';

/**
 * AuthGuard — redirects to /login if there is no active session.
 */
export default function AuthGuard({ children }) {
  const location = useLocation();
  const { isAuthenticated } = useSession();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
